<template>
    <div class="outter_container">
        <div class="index_container">
            <img class="bg_img" src="../../../assets/image/index-yn/jygm-home.jpg" />
            <img
                src="../../../assets/image/index-yn/lian.png"
                style="position: absolute; top: 60%; left: 37%;"
                class="index_img"
                @click="routerGo(2)"
            />
            <img
                src="../../../assets/image/index-yn/yagang.png"
                style="position: absolute; top: 36%; left: 49%;"
                class="index_img"
                @click="routerGo(3)"
            />
            <img
                src="../../../assets/image/index-yn/biandian.png"
                style="position: absolute; top: 67%; left: 28%;"
                class="index_img"
                @click="routerGo(1)"
            />
            <!-- <iframe
                id="d3-iframe"
                :class="['d3-iframe']"
                :src="`${d3Url}/static/ampersonbj/index.html`"
                v-if!="touch"
                frameborder="0"
            ></iframe>-->
        </div>
        <div class="index_lr index_lr_opa_y">
            <div class="top" :style="{ backgroundColor: backgroundColor }">
                <div class="title-wrap">
                    <div class="title-h2">聚元工贸</div>
                </div>
            </div>
            <div class="popss ssleft">
                <img src="../../../assets/image/index-yn/pop-left.png" />
                <img
                    src="../../../assets/image/index-yn/left_gk.png"
                    style="
                        height: 100%;
                        width: 3rem;
                        position: absolute;
                        left: 0;
                    "
                />
                <div class="left_fle left_mid">
                    <div class="left_mid_title">
                        <div>接入总览</div>
                    </div>
                    <div class="left_mid_cnt">
                        <div class="left_pic" v-for="(item, index) in picData" :key="index">
                            <img :src="item.img" alt />
                            <div class="left_pic_data">{{ item.name }}</div>
                            <div class="left_pic_data">{{ item.data }} {{ item.unit }}</div>
                        </div>
                    </div>
                </div>
                <div class="left_fle left_bot">
                    <div class="left_mid_title left_mid_margin">
                        <div>报警</div>
                    </div>
                    <div class="left_mid_cnt" style="display: block">
                        <div v-for="(item, index) in warnDatas" :key="index" class="warn-wrap">
                            <div class="warn-warp-item">
                                <span class="warn-wrap-title">名称</span>
                                <span class="warn-wrap-data">{{ item.point_name }}</span>
                            </div>
                            <div class="warn-warp-item">
                                <span class="warn-wrap-title">时间</span>
                                <span class="warn-wrap-data">{{ item.warn_time }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="popss ssright">
                <img src="../../../assets/image/index-yn/pop-right.png" />
                <div class="left_fle right_top">
                    <div class="left_mid_title">
                        <div>能耗</div>
                    </div>
                    <div class="right_mid_cnt right_cnt_sj">
                        <div
                            class="div-content"
                            v-for="(item, index) in dianliangData"
                            :key="index"
                        >
                            <div style="display: flex; align-items: center">
                                <div style="width: 20%">
                                    <img :src="item.img" style="width: 25px; height: auto" />
                                </div>
                                <div style="width: 40%">{{ item.name }}</div>
                                <div style="flex: 1">{{ item.data }}{{ item.unit }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="left_fle right_bot_chart1" style="padding: 10px 15px">
                    <v-chart :auto-resize="true" :options="line1" ref="line1" @click="clickYear" />
                </div>
                <div class="left_fle right_bot_chart2" style="padding: 10px 15px">
                    <v-chart :auto-resize="true" :options="line2" ref="line2" @click="clickMonth" />
                </div>
                <div class="left_fle right_bot_chart3" style="padding: 10px 15px">
                    <v-chart :auto-resize="true" :options="line3" ref="line3" />
                </div>
            </div>
        </div>
        <div class="data_tip">
            <div class="data_tip_div">
                <i>今日电量：</i>
                {{ dataTip[0] }} 万kWh&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <i>昨日电量：</i>
                {{ dataTip[1] }} 万kWh
            </div>
            <div class="data_tip_div">
                <i>P：</i>
                {{ dataTip[2] }} kW&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <i>Q：</i>
                {{ dataTip[3] }} kVar
            </div>
            <div class="data_tip_div">
                <i>COSA：</i>
                {{ dataTip[4] }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <i>COSB：</i>
                {{ dataTip[5] }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <i>COSC：</i>
                {{ dataTip[6] }}
            </div>
            <div class="data_tip_div">
                <i>Ia：</i>
                {{ dataTip[7] }} A&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <i>Ib：</i>
                {{ dataTip[8] }} A&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <i>Ic：</i>
                {{ dataTip[9] }} A
            </div>
            <div class="data_tip_div">
                <i>Ua：</i>
                {{ dataTip[10] }} kV&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <i>Ub：</i>
                {{ dataTip[11] }} kV&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <i>Uc：</i>
                {{ dataTip[12] }} kV
            </div>
        </div>
    </div>
</template>
<script>
import Bus from "../system/comons/bus";
import { departmentColor } from "@/utils/chart-color.js";
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import * as _api from "@/http/api.js";
import { getDataAll } from "@/http/http-60.js";
import * as api from "./api/index";
export default {
    name: "Main",
    components: {},
    data() {
        return {
            d3Url: process.env.VUE_APP_3D_URL,
            title: String,
            subTitle: String,
            top: 11,
            height: 89,
            current_year: "",
            current_month: "",
            currenr_day: "",
            selectDate: "",
            isUp: false,
            data1: 0,
            data2: 0,
            data3: 0,
            picData: [
                {
                    img: require("../../../assets/image/index-yn/zhuangji.png"),
                    name: "变电站",
                    data: "1",
                    unit: "个"
                },
                {
                    img: require("../../../assets/image/index-yn/peidianshi.png"),
                    name: "配电室",
                    data: "2",
                    unit: "个"
                },
                {
                    img: require("../../../assets/image/index-yn/jisuan.png"),
                    name: "数据采集装置",
                    data: "4",
                    unit: "个"
                },
                {
                    img: require("../../../assets/image/index-yn/caiji.png"),
                    name: "设备离线数",
                    data: "100",
                    unit: "个"
                },
            ],
            warnDatas: [], // 报警
            bianyaqiData: [],
            dianliangData: [
                {
                    img: require("../../../assets/image/index-yn/dianliang1.png"),
                    name: "昨日用电量",
                    data: "",
                    unit: "kWh"
                },
                {
                    img: require("../../../assets/image/index-yn/dianliang2.png"),
                    name: "今日用电量",
                    data: "",
                    unit: "kWh"
                },
            ],
            x1: [],
            y1: [],
            x2: [],
            y2: [],
            x3: [],
            y3: [],
            timer: null,
            dataTip: [],
        };
    },
    created() {
        this.getSysDate();
        // this.getCarbon();
        this.getData();
        this.setTimer();
    },
    mounted() {
    },
    methods: {
        setTimer() {
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.timer = setInterval(() => {
                this.getData();
            }, 5000);
        },
        /**
         * 获取系统时间
         */
        getSysDate(type) {
            _api.getSysDate1().then(res => {
                if (res && res.error_code === "0") {
                    this.selectDate = res.bus_json.sysdate;
                    this.current_year = res.bus_json.sysdate4;
                    this.getParamsList();
                    this.getIndex_warn();
                    this.getDateActivePower();
                    this.getEnergyTrendYear();
                }
            });
        },
        getData() {
            getDataAll(['1471348566789365760']).then(res => {
                let valueJson = res.bus_json;
                let point = valueJson['1471348566789365760'];
                //P
                this.dataTip[2] = (parseFloat(point && point.p_a) + parseFloat(point && point.p_b) + parseFloat(point && point.p_c)).toFixed(2);
                //Q
                const pf = (parseFloat(point && point.pf_a) + parseFloat(point && point.pf_b) + parseFloat(point && point.pf_c)) / 3;
                const p = parseFloat(point && point.p_a) + parseFloat(point && point.p_b) + parseFloat(point && point.p_c);
                this.dataTip[3] = (p / pf * Math.sqrt(1 - pf * pf)).toFixed(2);
                //COSA： COB   COSC
                this.dataTip[4] = point && point.pf_a;
                this.dataTip[5] = point && point.pf_b;
                this.dataTip[6] = point && point.pf_c;
                //ia ib ic
                this.dataTip[7] = point && point.a_a;
                this.dataTip[8] = point && point.a_b;
                this.dataTip[9] = point && point.a_c;
                //ua ub uc
                this.dataTip[10] = parseFloat(point && point.v_a).toFixed(2);
                this.dataTip[11] = parseFloat(point && point.v_b).toFixed(2);
                this.dataTip[12] = parseFloat(point && point.v_c).toFixed(2);
            });
        },
        /**
        * @description: 接入总览
        */
        getParamsList() {
            _api.getParamsList().then(res => {
                if (res && res.error_code === "0") {
                    this.picData[0].data = res.bus_json.index_1;
                    this.picData[1].data = res.bus_json.index_2;
                    this.picData[2].data = res.bus_json.index_3;
                    this.picData[3].data = res.bus_json.index_4;
                }
            });
        },
        /**
        * @description: 报警
        */
        getIndex_warn() {
            _api.getIndex_warn().then(res => {
                if (res && res.error_code == 0) {
                    this.warnDatas = res.bus_json;
                }
            })
        },
        /**
        * @description: 获得电量
        */
        getDateActivePower() {
            _api.getDateActivePower({ date: this.selectDate, point_id: "1468136607910719490" }).then(res => {
                if (res && res.error_code == 0) {
                    this.dianliangData[0].data = res.bus_json.active_power_yesterday;
                    this.dianliangData[1].data = res.bus_json.active_power_day;
                    this.dataTip[0] = (parseFloat(res.bus_json.active_power_day) / 10000).toFixed(2);
                    this.dataTip[1] = (parseFloat(res.bus_json.active_power_yesterday) / 10000).toFixed(2);
                }
            })
        },
        /**
        * @description: 能耗-年
        */
        getEnergyTrendYear() {
            _api.getEnergyTrendYear({ date: this.current_year, point_id: "1468136607910719490" }).then(res => {
                if (res && res.error_code == 0) {
                    this.x1 = res.bus_json.time_list;
                    this.y1 = res.bus_json.active_power_list;
                    this.current_month = this.selectDate.split("-")[1];
                    this.getEnergyTrendMonth()
                }
            })
        },
        /**
        * @description: 能耗-月
        */
        getEnergyTrendMonth() {
            _api.getEnergyTrendMonth({ date: `${this.current_year}-${this.current_month}`, point_id: "1468136607910719490" }).then(res => {
                if (res && res.error_code == 0) {
                    this.x2 = res.bus_json.time_list;
                    this.y2 = res.bus_json.active_power_list;
                    this.current_day = this.selectDate.split("-")[2];
                    this.getEnergyTrendDay()
                }
            })
        },
        /**
        * @description: 能耗-日
        */
        getEnergyTrendDay() {
            _api.getEnergyTrendDay({ date: `${this.current_year}-${this.current_month}-${this.current_day}`, point_id: "1468136607910719490" }).then(res => {
                if (res && res.error_code == 0) {
                    this.x3 = res.bus_json.time_list;
                    this.y3 = res.bus_json.active_power_list;
                }
            })
        },
        routerGo(diagramType) {
            this.$router.push({ name: "index-jygm", params: { diagramType: diagramType } });
        },
        /**
        * @description: 点击年
        */
        clickYear(val) {
            this.current_month = val.name;
            this.getEnergyTrendMonth();
        },
        /**
        * @description: 点击月
        */
        clickMonth(val) {
            this.current_day = val.name;
            this.getEnergyTrendDay();
        },
    },
    computed: {
        touch() {
            return this.$store.state.index.touch;
        },
        line1() {
            const options = {
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: ["年用电量"],
                    textStyle: {
                        color: "#64ffff"
                    },
                },
                grid: {
                    left: "4%",
                    right: "8%",
                    bottom: "0%",
                    top: "15%",
                    containLabel: true
                },
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        name: "月",
                        data: this.x1,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: "#fff"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#fff" // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "kWh",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: "#fff"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#fff" // 颜色
                            }
                        }
                    }
                ],
                series: [{
                    name: "年用电量",
                    type: "line",
                    data: this.y1,
                    itemStyle: {
                        color: "#64ffff"
                    }
                },]
            };
            return options;
        },
        line2() {
            const options = {
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: ["月用电量"],
                    textStyle: {
                        color: "#c6a3f6"
                    },
                },
                grid: {
                    left: "4%",
                    right: "8%",
                    bottom: "0%",
                    top: "15%",
                    containLabel: true
                },
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        name: "日",
                        data: this.x2,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: "#fff"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#fff" // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "kWh",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: "#fff"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#fff" // 颜色
                            }
                        }
                    }
                ],
                series: [{
                    name: "月用电量",
                    type: "line",
                    data: this.y2,
                    itemStyle: {
                        color: "#c6a3f6"
                    }
                },]
            };
            return options;
        },
        line3() {
            const options = {
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: ["日用电量"],
                    textStyle: {
                        color: "#fdca50"
                    },
                },
                grid: {
                    left: "4%",
                    right: "8%",
                    bottom: "0%",
                    top: "15%",
                    containLabel: true
                },
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        name: "时",
                        data: this.x3,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: "#fff"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#fff" // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "kWh",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: "#fff"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#fff" // 颜色
                            }
                        }
                    }
                ],
                series: [{
                    name: "日用电量",
                    type: "line",
                    data: this.y3,
                    itemStyle: {
                        color: "#fdca50"
                    }
                },]
            };
            return options;
        }
    },
    watch: {
        touch() {
            return this.$store.state.index.touch;
        }
    },
    destroyed() {
        window.removeEventListener("message", this.receiveMessage);
        Bus.$emit("toggleTopAndMenu", false);
        clearInterval(this.timer);
    }
};
</script>
<style lang="scss">
.outter_container {
    width: 100%;
    height: calc(100% + #{px2Rem(220px)});
    position: relative;
    .index_container {
        color: #fff;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        // background: url(../../../assets/image/index-yn/jygm-home.png);
        // background-size: 100% 100%;
        z-index: 1;
        .bg_img {
            width: 100%;
            height: auto;
        }
        .index_img {
            width: 9rem;
            cursor: pointer;
            transition: width 0.6s;
            &:hover {
                width: 10rem;
            }
        }
    }
    .index_lr {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
        .top {
            height: px2Rem(120px);
            // height: 135px;
            // height: 7rem;
            width: 100%;
            background-image: url("../../../assets/image/index/top.png");
            background-repeat: no-repeat;
            background-position: top center;
            background-size: auto 100%;
            position: relative;
            z-index: 1;
        }
        .popss {
            position: absolute;
            .left_fle {
                width: 100%;
                position: absolute;
                color: #fff;
                padding: 10px 35px;
                box-sizing: border-box;
                .left_mid_cnt {
                    display: flex;
                    flex-wrap: wrap;
                    //  justify-content: space-around;
                    // flex-flow: column;
                    .warn-wrap {
                        color: #56fcff;
                        font-size: px2Rem(16px);
                        border-bottom: 1px dotted #56fcff;
                        padding: px2Rem(10px);
                        box-sizing: border-box;
                        .warn-warp-item {
                            height: px2Rem(27px);
                            line-height: px2Rem(27px);
                            .warn-wrap-title {
                                display: inline-block;
                                margin-right: px2Rem(10px);
                            }
                            .warn-wrap-data {
                                color: #fff;
                            }
                        }
                    }
                    height: calc(100% - 20px);
                    .left_pic {
                        width: 45%;
                        height: 50%;
                        text-align: center;
                        padding-top: 3%;
                        img {
                            width: 25%;
                            height: 30%;
                            margin-bottom: px2Rem(10px);
                        }
                        .left_pic_data {
                            font-size: px2Rem(16px);
                            height: px2Rem(25px);
                            line-height: px2Rem(25px);
                        }
                    }
                    //margin-top: 1rem;
                    .div-content {
                        margin-top: 1rem;
                        .gaojing {
                            display: flex;
                            align-items: center;
                        }
                        .gaojing_one {
                            width: 5%;
                            img {
                                width: 15px;
                                height: 15px;
                            }
                        }
                        .gaojing_two {
                            width: 45%;
                            text-align: center;
                        }
                        .gaojing_three {
                            width: 50%;
                            display: flex;
                            flex-flow: column wrap;
                            .txt_elli {
                                width: 100%;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }
                        }
                    }
                    .byq_width {
                        width: 75px;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                    }
                }
                .right_mid_cnt {
                    display: flex;
                    justify-content: space-around;
                    flex-flow: column;
                    height: calc(100% - 20px);
                }
                .left_mid_title {
                    height: 30px !important;
                    width: 7.5rem;
                    background: url(../../../assets/image/index-yn/title.png);
                    background-size: 100% 100%;
                    margin-bottom: 5px;
                    // padding: 0 0 0 10px;
                    div {
                        text-align: center;
                        font-size: 0.6rem;
                        line-height: 30px;
                    }
                    &:first-child {
                        height: 20px;
                        line-height: 20px;
                        font-size: 0.6rem;
                    }
                }
                .left_mid_margin {
                    margin-left: 2rem;
                }
            }
        }
        .ssleft {
            top: 10%;
            left: 0;
            // transform: perspective(1000px) rotateY(15deg);
            // transition: all 0.6s;
            height: 85%;
            z-index: 999;
            img {
                width: 22rem;
                height: 100%;
                transition: width 0.6s;
            }
            // &:hover {
            //     top: 0;
            //     // transform: perspective(1000px) rotateY(0deg);
            //     height: 100%;
            //     img {
            //         width: 400px;
            //         height: 100%;
            //     }
            //     .left_top .left_top_wrapper > div .top_pic > img {
            //         width: 32px;
            //         height: 25px;
            //     }
            //     .left_mid_title {
            //         width: 150px;
            //         div {
            //             font-size: 0.8rem;
            //         }
            //         &:first-child {
            //             height: 25px;
            //             line-height: 25px;
            //         }
            //     }
            //     .left_top .left_top_wrapper > div > div {
            //         font-size: 0.7rem;
            //     }
            //     .left_mid .left_mid_cnt {
            //         .byq_width {
            //             width: 120px;
            //         }
            //         .div-content > div > div {
            //             font-size: 0.7rem;
            //         }
            //     }
            //     .left_bot .left_mid_cnt .div-content > div > div {
            //         font-size: 0.7rem;
            //     }
            //     .left_bot .echarts {
            //         width: 380px;
            //         height: 100%;
            //     }
            // }
            .left_top {
                width: 100%;
                height: 30%;
                position: absolute;
                top: 0;
                color: #fff;
                margin-left: 1.5rem;
                width: calc(100% - 1rem);
                .left_top_wrapper {
                    display: flex;
                    flex-flow: row wrap;
                    height: 100%;
                    padding: 0.8rem;
                    box-sizing: border-box;

                    > div {
                        height: 30%;
                        width: 50%;
                        text-align: center;
                        .top_pic {
                            height: 55%;
                            width: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            > img {
                                width: 24px;
                                height: 20px;

                                transition: none;
                            }
                        }
                        > div {
                            font-size: 0.6rem;
                            margin-top: 4px;
                        }
                    }
                    .left_new_con {
                        width: 90%;
                        height: 28%;
                        color: #2cd1ff;
                        background: url("../../../assets/image/index-yn/index03.png");
                        background-size: 100% 100%;
                        display: flex;
                        align-items: center;
                        .left_new_con_title {
                            width: 50%;
                            text-align: right;
                            line-height: 100%;
                            vertical-align: middle;
                        }
                        .left_new_con_data {
                            color: #2cffee;
                            font-size: 0.9rem;
                            margin: 0 0.2rem;
                        }
                    }
                    .ri-top-row {
                        width: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 1rem 0.5rem;
                        box-sizing: border-box;
                        // margin-top: 0.2rem;
                        img {
                            width: auto;
                            height: auto;
                        }
                        .ri-top-circle {
                            width: 5rem;
                            height: 5rem;
                            background: url("../../../assets/image/index-yn/index01.png")
                                no-repeat;
                            background-size: 100% 100%;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;

                            .val-detail {
                                color: rgb(222, 210, 112);
                                font-size: 0.6rem;
                                font-weight: bold;
                            }

                            .lab-detail {
                                color: #fff;
                                font-size: 0.5rem;
                                margin-top: 0.2rem;
                            }
                        }
                    }
                }
            }
            .left_mid {
                height: 31%;
                top: 0%;
                margin-left: 3rem;
                width: calc(100% - 3rem);
            }
            .left_bot {
                height: 65%;
                top: 33%;
                left: 6%;
                //  margin-left: 1rem;
                // .left_mid_cnt {
                //     margin-left: 0.5rem;
                // }
                .echarts {
                    width: 280px;
                    height: 100%;
                }
            }
            .sider-tit {
                position: absolute;
                top: 50%;
                left: 3px;
                transform: translate(0, -50%);
                width: 2rem;
                height: auto;
            }
        }
        .ssright {
            top: 10%;
            right: 0;
            // transform: perspective(1000px) rotateY(-15deg);
            // transition: all 0.6s;
            height: 85%;
            z-index: 999;
            img {
                width: 22rem;
                height: 100%;
                transition: width 0.6s;
            }
            // &:hover {
            //     top: 0;
            //     // transform: perspective(1000px) rotateY(0deg);
            //     height: 100%;
            //     img {
            //         width: 400px;
            //         height: 100%;
            //     }
            //     .left_mid_title {
            //         width: 150px;
            //         div {
            //             font-size: 0.8rem;
            //         }
            //         &:first-child {
            //             height: 25px;
            //             line-height: 25px;
            //         }
            //     }
            //     .right_top .right_mid_cnt .div-content > div > div {
            //         font-size: 0.7rem;
            //     }
            //     .right_bot .right_mid_cnt .div-content > div > div {
            //         font-size: 0.7rem;
            //     }
            //     .right_top_chart {
            //         .echarts {
            //             width: 380px;
            //         }
            //     }
            //     .right_bot_chart {
            //         .echarts {
            //             width: 380px;
            //         }
            //     }
            // }
            .right_top {
                width: 100%;
                height: 15%;
                position: absolute;
                top: 2%;
                color: #fff;
            }
            .right_top_chart {
                width: 100%;
                height: 30%;
                position: absolute;
                top: 27%;
                color: #fff;
                .echarts {
                    width: 280px;
                    height: 100%;
                }
            }
            .right_bot {
                width: 100%;
                height: 5%;
                position: absolute;
                top: 57%;
                color: #fff;
            }
            .right_bot_chart1 {
                width: 100%;
                height: 27%;
                position: absolute;
                top: 17%;
                color: #fff;
                .echarts {
                    width: 100%;
                    height: 100%;
                }
            }
            .right_bot_chart2 {
                width: 100%;
                height: 27%;
                position: absolute;
                top: 43%;
                color: #fff;
                .echarts {
                    width: 100%;
                    height: 100%;
                }
            }
            .right_bot_chart3 {
                width: 100%;
                height: 27%;
                position: absolute;
                top: 70%;
                color: #fff;
                .echarts {
                    width: 100%;
                    height: 100%;
                }
            }
            .right_cnt_sj {
                margin-left: 1rem;
            }
        }
    }
    .data_tip {
        width: fit-content;
        //height:200px;
        background-color: rgba(0, 0, 0, 0.4);
        position: relative;
        top: 63%;
        left: 56%;
        z-index: 2;
        border-radius: 10px;
        // display: flex;
        // flex-flow: column nowrap;
        // align-items: center;
        // justify-content: center;
        color: #56fcff;
        font-size: 0.7rem;
        padding: 0.6rem 1rem 1.2rem 1rem;
        i {
            color: #e7dc78ea;
        }
        .data_tip_div {
            border-bottom: 1px dotted #fff;
            padding: 0.6rem 0;
        }
    }
}

.index_lr_opa_y {
    opacity: 1;
}
.d3-iframe {
    width: 100%;
    height: 100%;

    margin-top: -1.6rem;
    position: absolute;
    left: 0;
    top: 0;
}
.el-progress-bar__outer {
    background-color: rgb(255 255 255 / 40%);
}
@media screen and (max-width: 1380px) {
    .ssleft .left_bot .left_mid_cnt .div-content {
        margin-top: 0.4rem !important;
    }
}
.index-container-n {
    height: 100%;
    top: 0%;
}
.index-container-y {
    height: 100%;
    // top: 15%;
}
.center-anim-n {
    // animation: center-n 2s;
}
@keyframes center-n {
    0% {
        height: 89%;
        top: 11%;
    }
    100% {
        height: 100%;
        top: 0;
    }
}
@-webkit-keyframes center-n {
    0% {
        height: 89%;
        top: 11%;
    }
    100% {
        height: 100%;
        top: 0;
    }
}
@-moz-keyframes center-n {
    0% {
        height: 89%;
        top: 11%;
    }
    100% {
        height: 100%;
        top: 0;
    }
}
.center-anim-y {
    // animation: center-y 2s;
}
@keyframes center-y {
    0% {
        height: 100%;
        top: 0;
    }
    100% {
        height: 89%;
        top: 11%;
    }
}
@-webkit-keyframes center-y {
    0% {
        height: 100%;
        top: 0;
    }
    100% {
        height: 89%;
        top: 11%;
    }
}
@-moz-keyframes center-y {
    0% {
        height: 100%;
        top: 0;
    }
    100% {
        height: 89%;
        top: 11%;
    }
}
.anim-opacityN {
    // animation: opacityN 2s;
}
@keyframes opacityN {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.8;
    }
    100% {
        opacity: 0;
    }
}
@-webkit-keyframes opacityN {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.8;
    }
    100% {
        opacity: 0;
    }
}
@-moz-keyframes opacityN {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.8;
    }
    100% {
        opacity: 0;
    }
}
.anim-opacityY {
    // animation: opacityY 2s;
}
@keyframes opacityY {
    0% {
        opacity: 0;
    }
    50% {
        opacity: 0.8;
    }
    100% {
        opacity: 1;
    }
}
@-webkit-keyframes opacityY {
    0% {
        opacity: 0;
    }
    50% {
        opacity: 0.8;
    }
    100% {
        opacity: 1;
    }
}
@-moz-keyframes opacityY {
    0% {
        opacity: 0;
    }
    50% {
        opacity: 0.8;
    }
    100% {
        opacity: 1;
    }
}
</style>
